import { render, staticRenderFns } from "./selectContact.vue?vue&type=template&id=a3881820&"
import script from "./selectContact.vue?vue&type=script&lang=js&"
export * from "./selectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports